import { create } from 'zustand'
import { persist, devtools, subscribeWithSelector } from 'zustand/middleware'

interface AppState {
   // example global state
   currentOrganization: string
   setCurrentOrganization: (currentOrganization: string) => void
}

export const useAppStore = create<AppState>()(
   subscribeWithSelector(
      devtools(
         persist(
            (set) => ({
               currentOrganization: '',
               setCurrentOrganization: (currentOrganization) =>
                  set({ currentOrganization }),
            }),
            {
               name: 'app-storage', // name of the item in storage
               getStorage: () => localStorage,
            }
         )
      )
   )
)
